export default __webpack_public_path__ + "static/media/grafema_angura_10.8a16a41c.mp4";